import { DOMAIN } from '../constants';

const pendingRequests = {};
const grammarCache = {};

export const getGrammar = async ({ request, getAPICallObject, activity }) => {
  if (grammarCache[activity]) {
    return grammarCache[activity];
  }
  if (pendingRequests[activity]) {
    return pendingRequests[activity];
  }
  const params = new URLSearchParams({ activity });
  pendingRequests[activity] = request(
    `${DOMAIN}/arya/api/v1/ask-aira-service/rule_expr/get_grammar?${params.toString()}`,
    getAPICallObject('GET'),
  )
    .then(response => {
      grammarCache[activity] = response.grammar;
      return response.grammar;
    })
    .finally(() => {
      delete pendingRequests[activity];
    });
  return pendingRequests[activity];
};
